import BaseComponent from 'foundation/base-component';
import anime from 'animejs';
import Stickyfill from 'stickyfilljs';
import { createBrowserHistory } from 'history';
import eventBus from '../../../general/js/event-bus';

export default class SubPageNav extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.activeNavLinkNode = null;
        this.currentContentNode = null;
        this.elementCoordinateTop = 0;

        this.links = this.refs.links;
        this.content = this.refs.content;

        this.history = createBrowserHistory();

        this.init();
    }

    init() {
        this.stickyfill();

        eventBus.addListener('venue-hero-init', this.venueHeroInit);
        eventBus.addListener('large-hero-init', this.largeHeroInit);

        this.onPopstate();
        this.tabsInit();
    }

    onDestroy() {
        eventBus.removeListener('venue-hero-init', this.venueHeroInit);
        eventBus.removeListener('large-hero-init', this.largeHeroInit);

        Stickyfill.remove(this.refs.nav);
    }

    setStyles(node) {
        const indent = node.offsetHeight;
        let className = '';

        switch (node) {
            case this.venueHeroSticky:
                className = 'is-venue-hero-sticky';
                break;
            case this.heroSticky:
                className = 'is-hero-sticky';
                break;
            default:
                className = '';
        }

        if (node) {
            this.refs.nav.classList.add(className);
            this.elementCoordinateTop = this.element.offsetTop - indent;
        }
    }

    venueHeroInit = (props) => {
        this.venueHeroSticky = props.venueHeroStickyRef;

        this.setStyles(this.venueHeroSticky);
    }

    largeHeroInit = (props) => {
        this.heroSticky = props.largeHeroStickyRef;

        this.setStyles(this.heroSticky);
    }

    onPopstate = () => {
        this.history.listen(() => {
            const hash = window.location.hash;

            if (!this.element && hash) return false;

            this.currentId = hash;

            if (!this.currentId) return false;

            if (this.activeNavLinkNode) {
                this.activeNavLinkNode.classList.remove('is-active');
            }

            if (!this.links) return false;

            const activeNavLinkNode = this.links.filter((item) => item.getAttribute('href') === hash);

            this.activeNavLinkNode = activeNavLinkNode[0];
            const key = this.links.indexOf(this.activeNavLinkNode);
            this.activeNavLinkNode.classList.add('is-active');
            this.showContent(this.content[key]);

            return true;
        });
    };

    stickyfill() {
        Stickyfill.add(this.refs.nav);
    }

    tabsInit() {
        if (!this.links) {
            return;
        }
        const activeNavLink = this.links.filter((item) => item.getAttribute('href') === window.location.hash);

        if (activeNavLink.length === 0) {
            this.links[0].classList.add('is-active');
        } else {
            this.links.forEach((link) => {
                link.classList.remove('is-active');
            });
            activeNavLink[0].classList.add('is-active');
        }

        Object.keys(this.links).forEach((key) => {
            const link = this.links[key];

            this.addListener(link, 'click', this.onLinkClick.bind(this, key));

            if (link.classList.contains('is-active')) {
                if (!this.activeNavLinkNode) {
                    this.activeNavLinkNode = link;

                    if (this.content[key]) {
                        this.content[key].classList.add('is-active');
                        this.currentContentNode = this.content[key];
                    }
                } else {
                    // remove dublicate state if found
                    link.classList.remove('is-active');
                }
            }
        });
    }

    onLinkClick(key, e) {
        e.preventDefault();

        this.elementCoordinateTop = this.element.offsetTop;

        // without animation
        // document.documentElement.scrollTop = this.elementCoordinateTop;

        anime({
            targets: document.documentElement,
            scrollTop: this.elementCoordinateTop,
            duration: 400,
            easing: 'easeOutQuad'
        });

        this.currentId = e.target.getAttribute('href');

        if (!document.getElementsByClassName('modal__container')[0]) {
            window.location.hash = this.currentId;
        }

        if (this.activeNavLinkNode) {
            this.activeNavLinkNode.classList.remove('is-active');
        }

        this.activeNavLinkNode = e.target;
        this.activeNavLinkNode.classList.add('is-active');
        this.showContent(this.content[key]);
    }

    showContent(contentNode) {
        if (this.currentContentNode) {
            if (this.currentContentNode === contentNode) {
                return;
            }

            this.currentContentNode.classList.remove('is-active');
        }

        contentNode.classList.add('is-active');
        this.currentContentNode = contentNode;
    }
}
